import * as octicons from '@primer/octicons-react';
import { Box, Text, Heading } from '@primer/react';
import Reveal from './Reveal';

function ProcessSteps({ steps, eyebrow = 'Our Process', title = 'A proven process, applied every time.' }) {
  return (
    <Box sx={{ backgroundColor: 'canvas.subtle', paddingX: ['24px', '48px', '100px'], paddingY: [7, 8, 9] }}>
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Reveal>
          <Text
            as="p"
            sx={{
              margin: 0,
              marginBottom: 2,
              fontSize: 1,
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'fg.muted',
            }}
          >
            {eyebrow}
          </Text>
          <Heading
            as="h2"
            sx={{
              margin: 0,
              marginBottom: [6, 7, 8],
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2rem', '2.5rem', '3rem'],
              color: 'fg.default',
              maxWidth: '640px',
            }}
          >
            {title}
          </Heading>
        </Reveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(5, 1fr)'],
            gap: [5, 5, 4],
            position: 'relative',
          }}
        >
          {steps.map((step, index) => {
            const Icon = octicons[step.icon];
            return (
              <Reveal key={step.title} delay={index * 0.1} sx={{ position: 'relative' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    marginBottom: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      flexShrink: 0,
                      background: 'linear-gradient(135deg, #60a5fa, #a78bfa)',
                      color: '#05070a',
                    }}
                  >
                    {Icon ? <Icon size={18} /> : null}
                  </Box>
                  <Text sx={{ fontSize: 0, fontWeight: 600, color: 'fg.muted' }}>
                    {String(index + 1).padStart(2, '0')}
                  </Text>
                </Box>

                <Heading
                  as="h3"
                  sx={{
                    margin: 0,
                    marginBottom: 2,
                    fontFamily: "'Fraunces', serif",
                    fontWeight: 400,
                    fontSize: 3,
                    color: 'fg.default',
                  }}
                >
                  {step.title}
                </Heading>
                <Text as="p" sx={{ margin: 0, fontSize: 1, lineHeight: 1.6, color: 'fg.muted' }}>
                  {step.description}
                </Text>
              </Reveal>
            );
          })}
        </Box>

        <Reveal delay={0.2}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              marginTop: [6, 7, 8],
              paddingY: 3,
              borderTop: '1px solid',
              borderColor: 'border.default',
            }}
          >
            <Text
              as="p"
              sx={{
                margin: 0,
                fontSize: 1,
                fontStyle: 'italic',
                color: 'fg.muted',
                textAlign: 'center',
              }}
            >
              ⟲ Every stage feeds the next, insights loop back continuously as the product evolves.
            </Text>
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
}

export default ProcessSteps;
